import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { ArrowLeft } from 'lucide-react';
interface Slide11Props {
  onNavigate: (slide: number) => void;
}
export function Slide11({
  onNavigate
}: Slide11Props) {
  return <SlideLayout onBack={() => onNavigate(7)} data-id="element-55">
      <div className="w-full max-w-6xl mx-auto space-y-6" data-id="element-56">
        <h1 className="text-3xl font-bold text-primary text-center" data-id="element-57">
          Vabysmo® - Information de prescription
        </h1>
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-teal-100/50" data-id="element-58">
          <div className="bg-gray-50 rounded-xl p-6 max-h-[60vh] overflow-y-auto border border-gray-200" data-id="element-59">
            <p className="text-[8px] text-gray-700 leading-tight text-justify" data-id="element-60">
              Vabysmo® Composition* Principe actif: Faricimabum. Excipients*
              Forme pharmaceutique et quantité de principe actif par unité*:
              Injectable par voie intravitréenne. Solution limpide à
              opalescente, incolore à jaune brunâtre. Flacon à dose unique en
              verre contenant 28,8 mg de faricimab dans 0,24 ml de solution.
              0,05 ml de solution injectable contient 6 mg de faricimab en dose
              unique. Indications/ Possibilités d'emploi: Traitement de la forme
              néovasculaire (humide) de la dégénérescence maculaire liée à l'âge
              (DMLA). Traitement de l'œdème maculaire diabétique (OMD).
              Traitement d'un œdème maculaire secondaire à une occlusion
              veineuse rétinienne (occlusion d'une branche veineuse rétinienne
              [OBVR] et occlusion de la veine centrale de la rétine [OVCR]).
              Posologie/Mode d'emploi: Généralités: Uniquement destiné à
              l'injection intravitréenne, doit être administré par un médecin
              qualifié et expérimenté. Chaque flacon ne doit être utilisé que
              pour traiter un seul œil. Forme néovasculaire (humide) de la
              dégénérescence maculaire liée à l'âge (DMLA): La dose recommandée
              est de 6 mg (0,05 ml) administrés en injection intravitréenne
              toutes les 4 semaines. Le traitement peut ensuite être
              individualisé dans le cadre d'un schéma thérapeutique T&E. Selon
              l'évaluation médicale de l'épaisseur de la rétine centrale et/ou
              de l'acuité visuelle du patient, l'intervalle entre les injections
              peut être prolongé jusqu'à un maximum de 16 semaines. En cas de
              détérioration de la CST et/ou de l'acuité visuelle, l'intervalle
              de traitement doit à nouveau être raccourci en conséquence. Chez
              certains patients, des injections toutes les 4 semaines peuvent
              s'avérer nécessaires. Œdème maculaire diabétique (OMD): La dose
              recommandée est de 6 mg administrés en injection intravitréenne
              toutes les 4 semaines lors des 4 premières injections. Le
              traitement peut ensuite être individualisé dans le cadre d'un
              schéma T&E. Selon l'évaluation médicale de l'épaisseur de la
              rétine centrale et/ou de l'acuité visuelle du patient,
              l'intervalle entre les injections peut être prolongé jusqu'à un
              maximum de 4 mois. En cas de détérioration de la CST et/ou de
              l'acuité visuelle, l'intervalle de traitement doit à nouveau être
              raccourci en conséquence. La surveillance mensuelle entre les
              injections n'est pas nécessaire. Œdème maculaire secondaire à une
              occlusion veineuse rétinienne (OBVR et OVCR): La dose recommandée
              de Vabysmo est de 6 mg administrés en injection intravitréenne
              toutes les 4 semaines; 3 injections mensuelles consécutives ou
              plus peuvent être nécessaires jusqu'à l'obtention de l'acuité
              visuelle maximale et/ou la disparition de tout signe d'activité de
              la maladie. Le traitement peut ensuite être individualisé dans le
              cadre d'un schéma T&E. Selon l'évaluation médicale de la CST et/ou
              de l'acuité visuelle du patient, l'intervalle entre les injections
              peut être prolongé. En cas de détérioration de la CST et/ou de
              l'acuité visuelle, l'intervalle de traitement doit être raccourci
              en conséquence et toute nouvelle prolongation de l'intervalle de
              traitement après stabilisation doit être soigneusement évaluée.
              Des intervalles entre les injections supérieurs à 4 mois n'ont pas
              été évalués. Durée du traitement: traitement à long terme. La
              sécurité et l'efficacité de Vabysmo n'ont pas été évaluées chez
              les patients pédiatriques. Prise retardée: En cas d'omission ou de
              retard de l'administration d'une injection, le patient doit être
              examiné par un médecin dès que possible. Le traitement doit
              ensuite être poursuivi selon le jugement du médecin. Vabysmo doit
              être arrêté si les résultats visuels et/ou anatomiques indiquent
              que la poursuite du traitement n'apporte pas de bénéfice au
              patient. Mode d'administration: Avant l'administration, Vabysmo
              doit être soumis à un contrôle visuel visant à rechercher des
              particules solides et un changement de coloration. Après
              l'injection intravitréenne, les patients doivent être surveillés
              et informés de la nécessité de signaler sans délai tout symptôme
              évocateur d'une endophtalmie. Contre-indications: Vabysmo est
              contre-indiqué chez les patients présentant une infection oculaire
              ou périoculaire. Vabysmo est contre-indiqué chez les patients
              présentant une inflammation intraoculaire active, une
              hypersensibilité connue au faricimab ou à l'un des excipients. Les
              réactions d'hypersensibilité peuvent se manifester sous la forme
              d'éruption cutanée, de prurit, d'urticaire, d'érythème ou
              d'inflammation intraoculaire sévère. Mises en garde et
              précautions*: Réactions liées à l'injection intravitréenne, Effets
              systémiques/Immunogénicité, Traitement bilatéral, Administration
              concomitante d'autres médicaments anti-VEGF, Interruption du
              traitement, Déchirure de l'épithélium pigmentaire rétinien,
              Groupes de patients chez lesquels les données sont limitées, Abus
              médicamenteux et dépendance au médicament, Remarques
              complémentaires: Vabysmo est essentiellement «sans sodium».
              Interactions*: Aucune étude d'interactions n'a été réalisée.
              Grossesse, Allaitement*: Femmes en âge de procréer: Les femmes en
              âge de procréer doivent utiliser des méthodes de contraception
              efficaces pendant le traitement par Vabysmo et jusqu'à 3 mois
              après l'administration de la dernière dose de Vabysmo. Grossesse,
              Accouchement, Allaitement, Fertilité: Il n'existe aucune donnée
              concernant l'emploi de Vabysmo, mais la nécessité clinique du
              traitement par Vabysmo doit être évaluée en considérant l'ensemble
              des effets indésirables. Effet sur l'aptitude à la conduite et
              l'utilisation de machines*: Vabysmo peut avoir une légère
              influence sur l'aptitude à la conduite ou l'utilisation de
              machines. Les patients ne doivent pas conduire de véhicules ou
              utiliser des machines tant qu'ils n'ont pas récupéré une fonction
              visuelle suffisante. Effets indésirables*: Fréquents: cataracte,
              hémorragie conjonctivale, décollement du corps vitré, augmentation
              de la pression intraoculaire, opacités vitréennes, déchirure de
              l'EPR, douleurs oculaires. Surdosage*: peut provoquer une
              augmentation de la pression intraoculaire. Propriétés/Effets*:
              Code ATC S01LA09 Remarques particulières* Préparation de
              l'administration: Vabysmo doit être soumis à un contrôle visuel à
              la sortie du réfrigérateur et avant l'administration. Le flacon ne
              doit pas être utilisé si des particules solides, une turbidité ou
              un changement de coloration sont visibles. Le contenu du flacon et
              l'aiguille-filtre de transfert sont stériles et sont à usage
              unique. Recourir à une technique aseptique pour préparer
              l'injection intravitréenne. Incompatibilités: En l'absence
              d'études de compatibilité, ce médicament ne doit pas être mélangé
              à d'autres médicaments. Stabilité: Le médicament ne doit pas être
              utilisé au-delà de la date figurant après la mention «EXP» sur
              l'emballage. Remarques particulières concernant le stockage:
              Conserver au réfrigérateur (2–8 °C). Ne pas secouer. Ne pas
              congeler. Conserver le récipient dans son carton pour le protéger
              de la lumière. Avant l'utilisation, le flacon non ouvert peut être
              conservé à température ambiante (de 20 °C à 25 °C) pendant une
              durée maximale de 24 heures. Tenir hors de la portée des enfants.
              Titulaire de l'autorisation: F. Hoffmann-La Roche SA, Bâle,
              Suisse. Mise à jour de l'information: Mai 2024.
            </p>
          </div>
        </div>
        <div className="flex justify-center gap-4 pt-2" data-id="element-61">
          <Button variant="secondary" onClick={() => onNavigate(7)} data-id="element-62">
            Back to additional resources
          </Button>
          <Button variant="primary" onClick={() => onNavigate(2)} data-id="element-63">
            <ArrowLeft className="w-5 h-5" data-id="element-64" />
            Back to main menu
          </Button>
        </div>
      </div>
    </SlideLayout>;
}